/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type { CreateSubscriptionRequest, SubscriptionDto } from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ApiSubscriptionsV2Controller<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags api-subscriptions-v-2-controller
   * @name Create2
   * @request POST:/api/v2/subscriptions
   */
  create = (data: CreateSubscriptionRequest, params: RequestParams = {}) =>
    this.http.request<SubscriptionDto, any>({
      path: `/v2/subscriptions`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createPath = '/v2/subscriptions'
  static createMethod = 'POST'
}
